import React, { useState } from 'react'
import { submitLead, track } from '../services/analytics'

export default function ContactForm() {
  const [form, setForm] = useState({
    name: '', email: '', company: '', phone: '', message: '', website: '', consentAck: false,
  })
  const [state, setState] = useState<'idle' | 'sending' | 'ok' | 'error'>('idle')
  const [error, setError] = useState<string | null>(null)

  const update = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const v = e.target.type === 'checkbox' ? (e.target as HTMLInputElement).checked : e.target.value
    setForm(f => ({ ...f, [k]: v }))
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (!form.name.trim() || (!form.email.trim() && !form.phone.trim())) {
      setError('Name and either email or phone are required.'); return
    }
    if (!form.consentAck) {
      setError('Please tick the consent box so we can reply to you.'); return
    }
    setState('sending')
    track('form_submit', { form: 'contact' })
    const res = await submitLead(form)
    if (res.ok) {
      setState('ok')
      setForm({ name: '', email: '', company: '', phone: '', message: '', website: '', consentAck: false })
    } else {
      setState('error'); setError(res.error || 'Something went wrong. Please try again.')
    }
  }

  const input: React.CSSProperties = {
    width: '100%', padding: '10px 12px', borderRadius: 6,
    border: '1px solid #d1d5db', font: 'inherit', boxSizing: 'border-box',
  }
  const label: React.CSSProperties = { display: 'block', marginBottom: 4, fontWeight: 600 }
  const row: React.CSSProperties = { marginBottom: 12 }

  if (state === 'ok') {
    return (
      <div style={{
        padding: 20, borderRadius: 8, background: '#ecfdf5',
        border: '1px solid #10b981', color: '#065f46', maxWidth: 560,
      }}>
        Thanks — we've received your message and will be in touch shortly.
      </div>
    )
  }

  return (
    <form onSubmit={onSubmit} style={{ maxWidth: 560 }} noValidate>
      <div style={row}>
        <label htmlFor="cf-name" style={label}>Your name *</label>
        <input id="cf-name" style={input} value={form.name} onChange={update('name')}
               onFocus={() => track('form_focus', { field: 'name' })} required />
      </div>
      <div style={row}>
         <label htmlFor="cf-email" style={label}>Email</label>
        <input id="cf-email" type="email" style={input} value={form.email} onChange={update('email')}
           onFocus={() => track('form_focus', { field: 'email' })} />
      </div>
      <div style={row}>
        <label htmlFor="cf-company" style={label}>Company</label>
        <input id="cf-company" style={input} value={form.company} onChange={update('company')} />
      </div>
      <div style={row}>
        <label htmlFor="cf-phone" style={label}>Phone</label>
        <input id="cf-phone" style={input} value={form.phone} onChange={update('phone')} />
      </div>
      <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px' }}>
        <label htmlFor="cf-website">Website</label>
        <input id="cf-website" tabIndex={-1} autoComplete="off" value={form.website} onChange={update('website')} />
      </div>
      <div style={row}>
        <label htmlFor="cf-message" style={label}>Message</label>
        <textarea id="cf-message" rows={5} style={{ ...input, resize: 'vertical' }}
                  value={form.message} onChange={update('message')} />
      </div>
      <div style={row}>
        <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontWeight: 400 }}>
          <input type="checkbox" checked={form.consentAck} onChange={update('consentAck')} />
          <span>
            I agree to LogiSelect Pty Ltd contacting me about my enquiry. My details
            will be stored securely and only used for that purpose. See our{' '}
            <a href="/privacy">privacy notice</a>.
          </span>
        </label>
      </div>
      {error && <div style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</div>}
      <button
        type="submit"
        disabled={state === 'sending'}
        style={{
          background: state === 'sending' ? '#9ca3af' : '#2563eb',
          color: 'white', border: 'none', borderRadius: 6,
          padding: '10px 18px', fontWeight: 600,
          cursor: state === 'sending' ? 'not-allowed' : 'pointer',
        }}
      >
        {state === 'sending' ? 'Sending…' : 'Send message'}
      </button>
    </form>
  )
}
